export default "__VITE_ASSET__CqTUwuZD__"